module.exports = "/cyber/_next/static/images/top10Slide-0101679c19b66f7db3e832bedfcc9b5c.jpg";